/* @flow */

const Environments = {
  ENV_LOCAL: 'local',
  ENV_DEV: 'dev',
  ENV_E2E: 'e2etesting',
  ENV_TEST: 'test',
  ENV_TESTING: 'testing',
  ENV_INT: 'int',
  ENV_PROD: 'prod'
};

export default Environments;
